/* eslint-disable */
/**
 * 二次封装 axios
 */
import axios from 'axios'
import { resolveRequestInfo, shouldSignWalletRequest } from '@/utils/request-info.mjs'
import {Toast, Dialog} from 'mand-mobile'
import router from '../router'
import {tokenKey} from '@/utils/token'
import global from '@/utils/global'
import store from '@/store'
import {ERROR_REQ_CODE} from '@/constants'
import i18n from '@/lang'
import { createRequestSignature, normalizeJwtToken } from '@/utils/request-signature.mjs'
const TIMEOUT = 20000 // 请求超时时间
const UNSIGNED_PATHS = new Set([
    '/func-whitelist/without',
    '/wallet/service-info',
    '/wallet/user-login',
    '/wallet/sms-login',
    '/wallet/open-login'
])

const axiosRequest = axios.create({
    baseURL: process.env.VUE_APP_BASE_URL,
    timeout: TIMEOUT,
    headers: {
        post: {'Content-Type': 'application/json'},
        'Accept-Language': i18n.locale
    },

    // 设置拦截器中使用的默认值
    loading: true,
    showMessage: true
})

// axiosRequest 请求拦截器
axiosRequest.interceptors.request.use(
    async (config) => {
        const requestInfo = resolveRequestInfo(config)
        const accessToken = global.getCookie()
        // 保留旧 Token 的跨服务传递；Bearer 与 HKDF 签名仅发送给钱包域名的受保护接口。
        config.headers.common[tokenKey] = accessToken
        if (!shouldSignWalletRequest(requestInfo, UNSIGNED_PATHS)) return config

        const token = normalizeJwtToken(accessToken)
        config.headers.Authorization = `Bearer ${token}`

        const signature = await createRequestSignature({
            accessToken: token,
            method: config.method,
            endpointUrl: requestInfo.endpointUrl,
            queryString: requestInfo.queryString,
            body: config.data
        })
        config.headers['X-Timestamp'] = signature.headers['X-Timestamp']
        config.headers['X-Nonce'] = signature.headers['X-Nonce']
        config.headers['X-Sign'] = signature.headers['X-Sign']
        if (config.data !== undefined && config.data !== null) {
            config.data = signature.minifiedBody
        }
        return config
    },
    (error) => {
        return Promise.reject(error)
    }
)

// axiosRequest 响应拦截器
axiosRequest.interceptors.response.use(
    (response) => {
        const result = response.data
        // if (response.config.loading) store.commit(UPDATE_REQUEST_COUNT, -1)
        // 请求成功
        if (result.code === 0) {
            return result.data
        }
        // 500101：已在其他设备登录  500102：无效token  500411: token超时
        if (result.code === ERROR_REQ_CODE.LOGIN_AGAIN || result.code === ERROR_REQ_CODE.TOKEN_ERROR || result.code === ERROR_REQ_CODE.TOKEN_TIMEOUT) {
            global.removeCookie()
            if(store.getters.isApp) {
                response.config.showMessage = false
                global.setLoginErrorHandle(result.code, result.message)
            } else {
                router.push({name: 'Register'})
            }
        } else if (result.code === ERROR_REQ_CODE.USER_ONLINE) { // 实名信息可开通用户已达上限
            response.config.showMessage = false
            Dialog.alert({ content: result.message + ` ${i18n.t('dialog_phone')}`  })
        }

        // 业务异常处理
        const msg = result.message
        if (response.config.showMessage) Toast.failed(`${msg}`,4000,null,document.body	,true)
        return Promise.reject(result)
    },
    async (error) => {
        // if (error.config.loading) store.commit(UPDATE_REQUEST_COUNT, -1)
        // 对于请求超时
        if (error.code === 'ECONNABORTED' || error.message === 'Network Error') {
            Toast.failed(i18n.t('network_error'),4000,null,document.body	,true)
            return Promise.reject(i18n.t('network_error'))
        }

        // TODO 统一处理全部的错误代码
        if (error.response) {
            let message = ''
            switch (error.response.status) {
                case 403:
                    break
                case 401:
                    global.removeCookie()
                    router.push({name: '401Page'})
                    break
                case 500:
                    message = i18n.t('server_error')
                    break
                case 502:
                    message = i18n.t('system_error')
                    break
                default:
            }
            Toast.failed(message,4000,null,document.body	,true)
            return Promise.reject(message) // 返回http状态
        }
        return Promise.reject(error)
    }
)

export default axiosRequest
